module.exports = __webpack_public_path__ + "static/media/profile-12.578fc668.jpeg";